'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { Button } from '@extern/ui/button';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@extern/ui/form';
import { InputPassword } from '@extern/ui/input';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@extern/ui/input-otp';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { AuthCard } from '@/app/(auth)/_partials/auth-card';
import { passwordWithConfirmationSchema } from '@/infra/schemas/auth';
import { useSignIn } from '../_hooks/use-sign-in';
const CodeSchema = z.object({
  code: z.string().min(6, {
    message: 'Please enter a valid code'
  })
});
export function SignInResetPassword() {
  const $ = _c(53);
  const {
    onSubmitNewPassword,
    onVerifyResetCode,
    onResendResetCode,
    fetchStatus,
    signIn
  } = useSignIn();
  const [resendTimeLeft, setResendTimeLeft] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      resolver: zodResolver(CodeSchema),
      defaultValues: {
        code: ""
      },
      mode: "onChange"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const codeForm = useForm(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      resolver: zodResolver(passwordWithConfirmationSchema),
      defaultValues: {
        password: "",
        confirmPassword: ""
      },
      mode: "onChange"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const passwordForm = useForm(t1);
  let t2;
  let t3;
  if ($[2] !== resendTimeLeft) {
    t2 = () => {
      let timer;
      if (resendTimeLeft > 0) {
        timer = setTimeout(() => setResendTimeLeft(_temp), 1000);
      }
      return () => clearTimeout(timer);
    };
    t3 = [resendTimeLeft];
    $[2] = resendTimeLeft;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  if (signIn.status === "needs_new_password") {
    let t4;
    if ($[5] !== onSubmitNewPassword || $[6] !== passwordForm) {
      let t5;
      if ($[8] !== onSubmitNewPassword) {
        t5 = data => onSubmitNewPassword(data.password);
        $[8] = onSubmitNewPassword;
        $[9] = t5;
      } else {
        t5 = $[9];
      }
      t4 = passwordForm.handleSubmit(t5);
      $[5] = onSubmitNewPassword;
      $[6] = passwordForm;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <AuthCard.Header><AuthCard.Title>Forgot Password</AuthCard.Title><AuthCard.Description>Please set your new password</AuthCard.Description></AuthCard.Header>;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== passwordForm.control) {
      t6 = <AuthCard.Content><FormField control={passwordForm.control} name="password" render={_temp2} /><FormField control={passwordForm.control} name="confirmPassword" render={_temp3} /></AuthCard.Content>;
      $[11] = passwordForm.control;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <AuthCard.Footer><Button aria-label="Update password" className="w-full" data-cy="update-password" type="submit">Update password</Button></AuthCard.Footer>;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] !== t6) {
      t8 = <AuthCard>{t5}{t6}{t7}</AuthCard>;
      $[14] = t6;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    let t9;
    if ($[16] !== t4 || $[17] !== t8) {
      t9 = <form className="w-full" onSubmit={t4}>{t8}</form>;
      $[16] = t4;
      $[17] = t8;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== passwordForm || $[20] !== t9) {
      t10 = <Form {...passwordForm}>{t9}</Form>;
      $[19] = passwordForm;
      $[20] = t9;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    return t10;
  }
  let t4;
  if ($[22] !== codeForm || $[23] !== onVerifyResetCode) {
    let t5;
    if ($[25] !== onVerifyResetCode) {
      t5 = data_0 => onVerifyResetCode(data_0.code);
      $[25] = onVerifyResetCode;
      $[26] = t5;
    } else {
      t5 = $[26];
    }
    t4 = codeForm.handleSubmit(t5);
    $[22] = codeForm;
    $[23] = onVerifyResetCode;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  let t5;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AuthCard.Header><AuthCard.Title>Verify your email</AuthCard.Title><AuthCard.Description>Enter the verification code sent to your email</AuthCard.Description></AuthCard.Header>;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  let t6;
  if ($[28] !== codeForm.control) {
    t6 = <FormField control={codeForm.control} name="code" render={_temp4} />;
    $[28] = codeForm.control;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  const t7 = resendTimeLeft > 0;
  let t8;
  if ($[30] !== onResendResetCode) {
    t8 = async () => {
      setResendTimeLeft(60);
      await onResendResetCode();
    };
    $[30] = onResendResetCode;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  const t9 = resendTimeLeft > 0 ? `${resendTimeLeft}s` : "60s";
  let t10;
  if ($[32] !== t9) {
    t10 = <span className="text-role-info">Resend ({t9})</span>;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== t10 || $[35] !== t7 || $[36] !== t8) {
    t11 = <Button appearance="ghost" className="gap-0" disabled={t7} onClick={t8} type="button">Didn't receive a code? {t10}</Button>;
    $[34] = t10;
    $[35] = t7;
    $[36] = t8;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== t11 || $[39] !== t6) {
    t12 = <AuthCard.Content><div className="flex flex-col items-center justify-center gap-y-2">{t6}{t11}</div></AuthCard.Content>;
    $[38] = t11;
    $[39] = t6;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  const t13 = fetchStatus === "fetching";
  const t14 = fetchStatus === "fetching";
  let t15;
  if ($[41] !== t13 || $[42] !== t14) {
    t15 = <AuthCard.Footer><Button aria-label="Verify code" className="w-full" disabled={t13} isLoading={t14} type="submit">Continue</Button></AuthCard.Footer>;
    $[41] = t13;
    $[42] = t14;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== t12 || $[45] !== t15) {
    t16 = <AuthCard>{t5}{t12}{t15}</AuthCard>;
    $[44] = t12;
    $[45] = t15;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  let t17;
  if ($[47] !== t16 || $[48] !== t4) {
    t17 = <form onSubmit={t4}>{t16}</form>;
    $[47] = t16;
    $[48] = t4;
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  let t18;
  if ($[50] !== codeForm || $[51] !== t17) {
    t18 = <Form {...codeForm}>{t17}</Form>;
    $[50] = codeForm;
    $[51] = t17;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  return t18;
}
function _temp4(t0) {
  const {
    field: field_1
  } = t0;
  return <FormItem className="w-full"><FormLabel>Email code</FormLabel><FormControl><InputOTP maxLength={6} {...field_1}><InputOTPGroup className="h-full w-full"><InputOTPSlot className="min-h-14 w-1/6 font-medium text-base" index={0} /><InputOTPSlot className="min-h-14 w-1/6 font-medium text-base" index={1} /><InputOTPSlot className="min-h-14 w-1/6 font-medium text-base" index={2} /><InputOTPSlot className="min-h-14 w-1/6 font-medium text-base" index={3} /><InputOTPSlot className="min-h-14 w-1/6 font-medium text-base" index={4} /><InputOTPSlot className="min-h-14 w-1/6 font-medium text-base" index={5} /></InputOTPGroup></InputOTP></FormControl><FormMessage className="text-center" /></FormItem>;
}
function _temp3(t0) {
  const {
    field: field_0
  } = t0;
  return <FormItem className="flex flex-col gap-2"><FormLabel>Confirm password</FormLabel><FormControl><InputPassword autoCapitalize="none" autoComplete="new-password" autoCorrect="off" data-cy="confirm-password" id="confirm-password" key="confirm-password" placeholder="********" type="password" {...field_0} /></FormControl><FormMessage /></FormItem>;
}
function _temp2(t0) {
  const {
    field
  } = t0;
  return <FormItem className="flex flex-col gap-2"><FormLabel>New password</FormLabel><FormControl><InputPassword autoCapitalize="none" autoComplete="new-password" autoCorrect="off" data-cy="password" id="password" key="password" placeholder="********" showTip={true} type="password" {...field} /></FormControl><FormMessage /></FormItem>;
}
function _temp(prev) {
  return prev - 1;
}